import React from 'react'
import { styled } from "../../../stitches.config";
import Logo from "../../atoms/Logo";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';

type IconCardProps = {
    text: string,
    title: string,
    children: JSX.Element | string;
}

const IconCard = ({ text, title, children }: IconCardProps) => {
    return (
        <Card>
            {children && children}
            <h3 className={h3()}>{title}</h3>
            <p className={p()}>{text}</p>
        </Card>
    )
}

export default IconCard;

const Card = styled('div', {
    display: 'flex !important',
    flexDirection: 'column',
    backgroundColor: '$grayscale0',
    padding: '24px 24px 32px 24px',
    alignSelf: 'normal',
    "@bp4": {
        padding: '40px 32px 40px 32px',
    },
    'img': {
        width: 'min-content',
    },
    'h3': {
        margin: "24px 0 0 0",
        fontSize: "18px",
        lineHeight: "24px",
        "@bp4": {
            fontSize: "24px",
            lineHeight: "30px",
        }
    },
    'p': {
        margin: "8px 0 0 0"
    }
})
